import {RouteObject} from 'react-router'
import {ErrorPage} from '@src/Layers/ErrorLayer/ErrorPage.tsx'
import { EmployeeView } from "./Views/Employee/CheckInOut/CheckInPage.tsx";
import { ManagerView } from "./Views/Manager/CheckInOut/CheckInPage.tsx";
import {useCredentialsStore} from "@src/Store/userStore.ts";


const Wrapper = () => {
    const {employee } = useCredentialsStore()
    if (!employee) return
    if (employee?.is_manager) return <ManagerView />
    return <EmployeeView />
}

export const path = 'check-in'

export const checkInRoute: RouteObject = {
    path,
    element: <Wrapper/>,
    errorElement: <ErrorPage header={false}/>,
}
